<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight" v-if="!logotext">
        <img class="navbar-brand-minimized" src="img/innoknight/logo.sm.png" width="23" height="30" alt="InnoKnight" v-if="!logotext">
        <span class="navbar-brand-full" v-if="logotext">{{logotext}}</span>
        <span class="navbar-brand-minimized" v-if="logotext">{{logotext}}</span>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="">
          <DefaultHeaderDropdown/>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb class="hidden" :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>

        <b-modal v-model="showPrivacyModal" :ok-title="$t('confirm')" :ok-only="true" size="xl">
          <div class="animated fadeIn">
            <h1 class="text-primary">隱私政策</h1>
            <br>
            <p class="text-dark">非常歡迎您光臨「創玖科技充電計費服務網站」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</p>
            <br>
            <h3 class="text-primary">一、隱私權保護政策的適用範圍</h3>
            <p class="text-dark">隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。</p>
            <br>
            <h3 class="text-primary">二、個人資料的蒐集、處理及利用方式</h3>
            <ul class="text-dark">
              <li>當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。</li>
              <li>本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。</li>
              <li>於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的 IP 位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</li>
              <li>為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</li>
              <li>您可以隨時向我們提出請求，以更正或刪除本網站所蒐集您錯誤或不完整的個人資料。</li>
            </ul>
            <br>
            <h3 class="text-primary">三、資料之保護</h3>
            <ul class="text-dark">
              <li>本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。</li>
              <li>如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</li>
            </ul>
            <br>
            <h3 class="text-primary">四、網站對外的相關連結</h3>
            <p class="text-dark">本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>
            <br>
            <h3 class="text-primary">五、與第三人共用個人資料之政策</h3>
            <p class="text-dark">本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。</p>
            <p class="text-dark">前項但書之情形包括不限於：</p>
            <ul class="text-dark">
              <li>經由您書面同意。</li>
              <li>法律明文規定。</li>
              <li>為免除您生命、身體、自由或財產上之危險。</li>
              <li>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</li>
              <li>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
              <li>有利於您的權益。</li>
              <li>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</li>
            </ul>
            <br>
            <h3 class="text-primary">六、Cookie 之使用</h3>
            <p class="text-dark">為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行 。</p>
            <br>
            <h3 class="text-primary">七、隱私權保護政策之修正</h3>
            <p class="text-dark">本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。</p>
            <br>
          </div>
        </b-modal>
      </main>
      <!-- <AppAside fixed>
        <!--aside-->
        <!-- <DefaultAside/> -->
      <!-- </AppAside> -->
    </div>
    <TheFooter class="footer-flex">
      <!--footer-->
      <div>
        <!--<router-link to="privacy">{{$t('privacy_policy')}}</router-link>。-->
        <span @click="popPrivacyModal" class="clickable-text">{{$t('privacy_policy')}}</span>。
        <span v-html="PrivacyPolicy"></span>
        {{$t('innoknight') + '©' + thisyear}} 
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import config from '@/config/global'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    // AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      let app         = this;
      let adminuser   = this.$state.$get('adminuser');
      let enduser     = this.$state.$get('user');
      let is_frontend = false;

      // console.info('enduser: ', enduser);
      // console.info('adminuser: ', adminuser);

      if(enduser && enduser._nav && enduser._nav.length){
        app.navItems = [];
        let updated_is_front = false;
        enduser._nav.map((menu) => {
          //i18n
          //console.info('menu.name: ', menu.name);

          let badge = null;
          if(menu.badge && menu.badge.length > 2){
            try {
              badge = JSON.parse(menu.badge);
            } catch (error) {console.error(`Unable to parse JSON badge from ${menu.name} with value: ${menu.badge}`);}
          }
          menu.badge = badge;
          app.navItems.push(menu);

          if(!updated_is_front){
            if(app.$route.fullPath.indexOf(menu.url) !== -1){
              is_frontend      = true;
              updated_is_front = true;
            };
          }
        });
      }

      if(!is_frontend && adminuser && adminuser._nav && adminuser._nav.length){
        app.navItems = [];
        let ccff = this.$state.$get('ccff');
        console.info('ccff:', ccff);

        adminuser._nav.map((menu) => {
          let badge = null;
          if(menu.badge && menu.badge.length > 2){
            try {
              badge = JSON.parse(menu.badge);
            } catch (error) {console.error(`Unable to parse JSON badge from ${menu.name} with value: ${menu.badge}`);}
          }

          if(ccff !== 'N/A' && menu.is_sudo){
            return true;
          }

          menu.badge = badge;
          app.navItems.push(menu);
        });
      }

      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  data () {

    const this_year = new Date();

    return {
      navItems: [],
      footer: config.footer,
      logotext: config.logotext,
      thisyear: this_year.getFullYear(),
      showPrivacyModal: false
    }
  },//eo data

  beforeMount() {

    let admin_user = this.$route.path.indexOf('/dashboard/showdevice') !== -1 ? false : true;
    
    let user = this.$state.$get((admin_user ? 'adminuser' : 'user'));
    let user_key = (this.$route.path.indexOf('/dashboard/showdevice') !== -1) ? 'user' : 'adminuser';

    // console.info('uuid 1:', this.$route);
    
    let is_showdevice = this.$route.path.indexOf('/dashboard/showdevice') !== -1;

    //with predefinded UUID
    if(this.$route && this.$route.query && this.$route.query.uuid){
      this.$state.$set('uuid', this.$route.query.uuid);
    }

    // console.info('uuid:', this.$state.$get('uuid'));

    if(!user && !is_showdevice){

      let target = (user_key === 'adminuser') ? '/' : '/';

      this.$state.$set('error', config.error.INVALID_USER);

      this.$router.push(target);
    } else {
      this.userprofile = user;
    }

    return false;
  },//eo beforeMount

  mounted() {
    if(config.overwritetitle){
      // console.info('config.overwritetitle:', config.overwritetitle);
      document.title = config.overwritetitle;
    }
  },

  methods: {
    popPrivacyModal() {
      this.showPrivacyModal = true;
    }
  },

}
</script>

<style type="text/css">
.grecaptcha-badge{
  display: none;
}
.app-footer{
  text-align: justify;
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}
.clickable-text {
  cursor: pointer;
  color: #3366BB;
  text-decoration: underline;
}
.footer-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
